import { TRACKING_CURRENCY } from '../../const';
import { getCartItemsTracking } from '../../helpers';
import type { RootState } from 'core/store';

export const cartView = (action: any, prevState: RootState) => {
  if (!action.payload) {
    return;
  }

  return {
    event: 'view_cart',
    ecommerce: {
      currency: TRACKING_CURRENCY,
      value: prevState.cart.data?.totalNum,
      coupon: prevState.cart.data?.coupon?.description,
      items: getCartItemsTracking(prevState),
    },
  };
};
